import { render, staticRenderFns } from "./profiloUtente.html?vue&type=template&id=72050cc1&"
import script from "./ProfiloUtente.vue?vue&type=script&lang=js&"
export * from "./ProfiloUtente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports